// Task item variant for nested child tasks.
// @ts-check
import { memo } from 'react';
import TaskItem from '@/features/tasks/components/items/TaskItem';

/**
 * TaskItemNested - Lightweight view for the hierarchy within the Detail Pane.
 * @param {{ task: Task } & Record<string, any>} props
 */
const TaskItemNested = (props) => {
  return <TaskItem {...props} view="nested" />;
};

export default memo(TaskItemNested);
